import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Breadcrumb, Empty, Alert, Input, Button } from 'antd';
import Grid from '@material-ui/core/Grid';
import AddCompanyButton from './AddCompanyButton';
import CompanyCard from './CompanyCard';
import { fetchCompanies } from '../../../redux/Company/actions';

const { Search } = Input;

export const Companies = () => {
  const dispatch = useDispatch();
  const companies = useSelector((state) => state.companies.companies || []);
  const [companySearch, setCompanySearch] = useState([]);
  const [searchMode, setSearchMode] = useState(false);
  const error = useSelector((state) => state.companies.error);

  useEffect(() => {
    dispatch(fetchCompanies());
  }, [dispatch]);

  const handleSearch = (value) => {
    if (value.length > 0) {
      setSearchMode(true);
      const filteredCompanies = companies.filter((company) =>
        company.name.toLowerCase().includes(value.toLowerCase())
      );
      setCompanySearch(filteredCompanies);
    } else {
      setSearchMode(false);
      setCompanySearch([]);
    }
  };

  return (
    <div>
      {error && (
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}
      <Breadcrumb style={{ margin: '16px 0' }}>
        <Breadcrumb.Item>Companies</Breadcrumb.Item>
        <div style={{ float: 'right', marginTop: 20 }}>
          <Grid container>
            <Grid item>
              <Search
                placeholder="Search"
                onChange={(e) => {
                  if (e.target.value.length === 0) setSearchMode(false);
                }}
                style={{ minWidth: 150, maxWidth: 220 }}
                enterButton
                onSearch={handleSearch}
              />
              <AddCompanyButton onRefresh={() => dispatch(fetchCompanies())} />
            </Grid>
          </Grid>
        </div>
      </Breadcrumb>
      <br />
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container justify="center" spacing={2}>
            {searchMode ? (
              companySearch.length === 0 ? (
                <Empty />
              ) : (
                companySearch.map((item, index) => (
                  <Grid key={index} item>
                    <CompanyCard item={item} onRefresh={() => dispatch(fetchCompanies())} />
                  </Grid>
                ))
              )
            ) : companies && companies.length > 0 ? (
              companies.map((item, index) => (
                <Grid key={index} item>
                  <CompanyCard item={item} onRefresh={() => dispatch(fetchCompanies())} />
                </Grid>
              ))
            ) : (
              <Empty />
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Companies;
